export const TIPI_COSTO = [
  { value: "fornitura", label: "Fornitura da scegliere", short: "Fornitura", cls: "bg-emerald-100 text-emerald-800" },
  { value: "consumo", label: "Materiale di consumo", short: "Consumo", cls: "bg-zinc-100 text-zinc-700" },
  { value: "lavorazione", label: "Lavorazione / subappalto", short: "Lavorazione", cls: "bg-blue-100 text-blue-800" },
  { value: "servizio", label: "Servizio (pratiche, tecnici, collaboratori)", short: "Servizio", cls: "bg-amber-100 text-amber-800" },
];
export const tipoCostoInfo = (v) => TIPI_COSTO.find((t) => t.value === v) || TIPI_COSTO[2];
export const tipoCostoDi = (voce) => voce?.tipo_costo || voce?.tipo_costo_eff || "lavorazione";
